import { breakpoint } from '@carvana/helios-layout';
import { Link } from '@carvana/helios-navigation';
import { border, borderRadius, canvas, text } from '@carvana/helios-styles';
import { body, heading } from '@carvana/helios-typography';
import Image from 'next/image';
import styled from 'styled-components';

export const Background = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px 24px;

  ${breakpoint.sm`
    margin: 40px 32px;
  `}

  ${breakpoint.md`
    margin: 0 32px;
  `}
  
  &.boxshadow {
    margin: 56px 24px;
  }
`;

export const Container = styled.div`
  border: 1px ${border.weak} solid;
  border-radius: 16px;
  background-color: ${canvas.default};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
  max-width: 559px;
  width: 100%;
  z-index: 1;

  ${breakpoint.sm`
    flex-direction: row;
    max-width: 911px;
  `}

  ${breakpoint.md`
    max-width: 1056px;
  `}
  
  &.boxshadow {
    border: none;
    border-radius: ${borderRadius.xl};
    box-shadow: 0px 8px 28px 0px rgba(36, 41, 46, 0.04), 0px 4px 8px 0px rgba(36, 41, 46, 0.08);
  }
`;

export const HeadLine = styled.h2`
  ${heading.xl};
  color: ${text.strong};
  padding: 0 24px;

  ${breakpoint.md`
    ${heading['2Xl']};
  `}
`;

export const ImgWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${breakpoint.sm`
    width: unset;
    margin-right: 16px;
  `}
`;

export const LogoWrapper = styled.div`
  padding: 24px 24px 0;
  margin-bottom: 16px;

  ${breakpoint.sm`
    padding-top: 0px;
  `}
`;

export const Text = styled.p`
  ${body.md};
  padding: 8px 24px;
  color: ${text.default};

  ${breakpoint.sm`
    ${body.lg};
  `}
`;

export const TextContainer = styled.div`
  width: 100%;

  ${breakpoint.sm`
    margin-right: 40px;
  `}

  ${breakpoint.md`
    margin-right: 0px;
    min-width: 433px;
  `}
`;

export const StyledImage = styled(Image)`
  width: 307px;
  height: auto;
  display: none;

  ${breakpoint.sm`
    width: 215px;
    height: auto;
    display: block;
  `}

  &.mobile {
    display: block;
    margin: 0;

    ${breakpoint.sm`
      display: none;
    `}
  }
`;

export const StyledLink = styled(Link)`
  display: inline;
  margin-left: 4px;
`;

export const RedirectLink = styled.a`
  margin-right: 40px;
  min-width: 135px;
  display: none;
  text-decoration: none;

  button {
    text-decoration: none;
  }

  ${breakpoint.sm`
    min-width: 196px;
    display: none;
  `}

  ${breakpoint.md`
    display: block;
  `}

  &.tablet {
    margin-top: 16px;
    margin-left: 24px;
    display: block;

    ${breakpoint.md`
      display: none;
    `}
  }
`;
